import axiosHttp from "./interceptor.service";

const getAllProject = () => {
  return axiosHttp.get("/lmt/getAllProject");
};

const getReports = (requestedData) => {
  return axiosHttp.post("/lmt/getReports", requestedData);
};

const getRevertById = (id) => {
  return axiosHttp.get(`/lmt/getRevertById/${id}`);
};

const updateRevert = (requestedData) => {
  return axiosHttp.post("/lmt/updateRevert/", requestedData);
};
const getAttendance = (requestedData) => {
  return axiosHttp.post("/lmt/getAttendance/", requestedData);
};

const getRevertedData = (requestedData) => {
  return axiosHttp.post("/lmt/getRevertedData", requestedData);
};

// =============== get Project Working Report =================
const getProjectWorkingReport = ({
  page,
  limit,
  sort,
  search,
  startDate,
  endDate,
  userId,
  issueType,
  projectIds,
  payable
} = {}) => {
  return axiosHttp.get("/lmt/getProjectWorkingReport", {
    params: { sort, limit, page, search, startDate, endDate, userId, issueType, projectIds, payable },
  });
};

// =============== get Daily Working Report =================
const getDailyWorkingReport = ({
  page,
  limit,
  sort,
  search,
  userId,
  date
} = {}) => {
  return axiosHttp.get("/lmt/getDailyWorkingReport", {
    params: { sort, limit, page, search, userId, date },
  });
};

// =============== get Project Daily Report =================
const getProjectDailyReport = ({
  page,
  limit,
  sort,
  search,
  projectId,
  date
} = {}) => {
  return axiosHttp.get("/lmt/getProjectDailyReport", {
    params: { sort, limit, page, search, projectId, date },
  });
};

// =============== get Parent Tasks by Project =================
const getParentTasksByProject = (projectId) => {
  return axiosHttp.get("/lmt/getParentTasksByProject", {
    params: { projectId },
  });
};

// =============== get Parent Task Report =================
const getParentTaskReport = ({
  projectId,
  parentTaskId,
  startDate,
  endDate,
  userId
} = {}) => {
  return axiosHttp.get("/lmt/getParentTaskReport", {
    params: { projectId, parentTaskId, startDate, endDate, userId },
  });
};

// =============== get Task Report =================
const getTaskReport = ({
  projectId,
  startDate,
  endDate,
  userId,
  page,
  limit,
  sortBy,
  sortOrder,
  issueType,
  payable
} = {}) => {
  return axiosHttp.get("/lmt/getTaskReport", {
    params: { projectId, startDate, endDate, userId, page, limit, sortBy, sortOrder, issueType, payable },
  });
};

const downloadTaskReport = ({
  projectId,
  startDate,
  endDate,
  userId,
  issueType,
  payable
} = {}) => {
  return axiosHttp.get("/lmt/downloadTaskReport", {
    params: { projectId, startDate, endDate, userId, issueType, payable },
    responseType: "blob",
  });
};

const downloadProjectWorkingReport = ({
  startDate,
  endDate,
  userId,
  issueType,
  projectIds
} = {}) => {
  return axiosHttp.get("/lmt/downloadProjectWorkingReport", {
    params: { startDate, endDate, userId, issueType, projectIds },
    responseType: "blob",
  });
};

const getClientTaskReport = ({
  page,
  limit,
  sort,
  search,
  startDate,
  endDate,
  userId,
  issueType,
  projectIds
} = {}) => {
  return axiosHttp.get("/lmt/getClientTaskReport", {
    params: { sort, limit, page, search, startDate, endDate, userId, issueType, projectIds },
  });
};

const downloadClientTaskReport = ({
  startDate,
  endDate,
  userId,
  issueType,
  projectIds
} = {}) => {
  return axiosHttp.get("/lmt/downloadClientTaskReport", {
    params: { startDate, endDate, userId, issueType, projectIds },
    responseType: "blob",
  });
};

const getClientTaskDetails = (data) => {
  return axiosHttp.get("/lmt/getClientTaskDetails", { params: data });
};

// =============== get Issue Wise Report =================
const getIssueWiseReport = ({
  startDate,
  endDate,
  userId,
  projectIds,
  payable
} = {}) => {
  return axiosHttp.get("/lmt/getIssueWiseReport", {
    params: { startDate, endDate, userId, projectIds, payable },
  });
};

const downloadIssueWiseReport = ({
  startDate,
  endDate,
  userId,
  projectIds,
  payable
} = {}) => {
  return axiosHttp.get("/lmt/downloadIssueWiseReport", {
    params: { startDate, endDate, userId, projectIds, payable },
    responseType: "blob",
  });
};

export {
  getClientTaskDetails,
  getAllProject,
  getReports,
  getRevertById,
  updateRevert,
  getAttendance,
  getRevertedData,
  getProjectWorkingReport,
  getDailyWorkingReport,
  getProjectDailyReport,
  getParentTasksByProject,
  getParentTaskReport,
  getTaskReport,
  downloadTaskReport,
  downloadProjectWorkingReport,
  getClientTaskReport,
  downloadClientTaskReport,
  getIssueWiseReport,
  downloadIssueWiseReport,
};

